import client from "../config/api.config";

const getWebClient = () => client.apiClient;

export interface AppNoticeResolveResponse {
  featureType?: "MAINTENANCE" | "ANNOUNCEMENT";
  enabled: boolean;
}

export interface AppConfigResolveResponse {
  enabled: boolean;
  messageEn?: string | null;
  messageFr?: string | null;
  messageAr?: string | null;
  bgColor?: string | null;
}

/**
 * Resolve the MAINTENANCE feature flag for the current environment.
 * The endpoint is public (no JWT required) and never 404s — it always
 * returns `{ enabled: boolean }` (omitting `featureType` when no rule matches).
 *
 * Note: `feature_type` here is a query parameter, not a JSON body field — the
 * BFF's `@RequestParam` for this route is still named snake_case (query
 * params are a separate contract from JSON payload casing).
 */
export function resolveMaintenance(environment: string) {
  return getWebClient().request<AppNoticeResolveResponse>({
    method: "GET",
    url: "/public/app-config/resolve",
    params: {
      feature_type: "MAINTENANCE",
      environment,
    },
  });
}

/**
 * Resolve the ANNOUNCEMENT feature flag for the current environment and country.
 * Returns `enabled` plus optional per-language `messageEn`, `messageFr`, `messageAr` fields.
 */
export function resolveAnnouncement(environment: string, country?: string) {
  return getWebClient().request<AppConfigResolveResponse>({
    method: "GET",
    url: "/public/app-config/resolve",
    params: {
      feature_type: "ANNOUNCEMENT",
      environment,
      ...(country && { country }),
    },
  });
}
